import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.bootstrap5.min.css";
import "./tom_select.css";

export default class extends Controller {
  static values = {
    options: Object,
    clearButton: Boolean,
    redirectUrls: Object,
  };

  connect() {
    const settings = Object.assign(this.defaultOptions(), this.optionsValue);
    this.tomSelect = new TomSelect(this.element, settings);

    this.tomSelect.on("item_add", (value) => {
      this.tomSelect.setTextboxValue("");

      // Handle redirect if URLs provided
      if (this.hasRedirectUrlsValue && this.redirectUrlsValue[value]) {
        window.open(this.redirectUrlsValue[value], "_blank");
        this.tomSelect.clear();
      }
    });

    this.accessibilitySettings();
  }

  defaultOptions() {
    return {
      valueField: "id",
      labelField: "name",
      persist: false,
      createOnBlur: true,
      hidePlaceholder: true,
      searchField: "name",
      maxOptions: null, // default limits options to 50
      plugins: {
        clear_button: {
          title: "Remove all selected options",
          html: this.clearButtonHtml(),
        },
      },
      render: {
        no_results: this.noResults(),
        option: this.optionHtml(),
      },
      // Bootstrap theme settings
      theme: "bootstrap5",
      controlInput: "<input>",
      selectOnTab: true,
    };
  }

  autoSubmit() {
    this.element.form.submit();
  }

  listenAutoSubmit() {
    this.listener = this.element.form.addEventListener("focusout", () => {
      this.autoSubmit();
      this.listener.removeEventListener("focusout");
    });
  }

  optionHtml() {
    return (item) => {
      return `<div aria-label="Select Option - ${item.name}">${item.name}</div>`;
    };
  }

  clearButtonHtml() {
    return (data) => {
      if (data && this.clearButtonValue) {
        return "<span class='justify-right mr-15 icon'><i class='pt-3 button is-danger is-outlined far fa-times'></i></span>";
      } else {
        return "<span></span>";
      }
    };
  }

  noResults() {
    return (data, escape) => {
      return (
        '<div class="no-results">No results found for "' +
        escape(data.input) +
        '"</div>'
      );
    };
  }

  disconnect() {
    this.tomSelect.destroy();
    this.tomSelect = null;
  }

  accessibilitySettings() {
    // Obtain the aria-label from the main/hidden select
    // or obtain from the default option
    const ariaLabel =
      this.element.getAttribute("aria-label") || this.element.firstChild.text;
    if (ariaLabel) {
      this.listbox().setAttribute("aria-label", ariaLabel);
    }
  }

  listbox() {
    return this.element.parentElement.querySelector(".ts-dropdown").lastChild;
  }
}
